<div class="footer-div">
  <div class="footer-links">
    <mat-list>
      <h4>{{title}}</h4>
      <a mat-list-item href="mailto:{{fcItEmail}}?subject={{fcItSubject}}&body={{fcItBody}}">Contact us</a>
      <a mat-list-item href="#">eAssets Roots</a>
    </mat-list>
    <mat-list>
      <h4>Other Sites</h4>
      <a mat-list-item href="https://www.forestryengland.uk/">Forestry England</a>
    </mat-list>
  </div>
  <div class="app-info">
    <div class="version-info" [ngClass]="{'hidden': !appVersionVisible}">
      {{appVersion}}
    </div>
    <div class="time-info">
      Server Time: {{formattedCurrentDateTime}}
    </div>
    <div *ngIf="tokenExpiryAt != null" class="time-info">Login Expires At: {{tokenExpiryAtDisplay}} Login Expires In:
      {{tokenExpiryInDisplay}}</div>
  </div>
</div>
